export default {
  fluidBaselineSampleID: { field: 'fluidBaselineSampleID', fieldType: 'numeric' },
  fluidBaselineSampleNumber: { field: 'fluidBaselineSampleNumber', fieldType: 'numeric', label: 'Baseline Sample' },
  fluidBaselineSampleDate: { field: 'fluidBaselineSampleDate', fieldType: 'text', label: 'Baseline Sample' }
};
